import {ID, Model, ResponseSerialize} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'

export default class CargaDanfeRequest extends Model {
  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Carga)
  cargas: Carga[] = []

  forcar: boolean | null = null

  naoValidar: boolean | null = null

  viaPainel: boolean | null = null

  ftpSaraiva: boolean | null = null

  cielo: boolean | null = null
}
